import React, { useState } from "react";
import { Button, Row, Col, message, Modal, Descriptions, Select } from "antd";
import {
  CloudDownloadOutlined,
  UserAddOutlined,
  CopyOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { useGetLeads, patchPic } from "apis/lead";
import { useGetUsers } from "apis/user";
import Title from "components/Title/Title";
import ExpandableRow from "./component/expandableRow";
import { buildLeadFormUri, buildAWPersonalUri } from "utils/routes";
import {
  getColumnFilterSearchProps,
  constructColumn,
  handleOnAggregationTableChange,
} from "utils/table/table";
import moment from "moment";
import { getUserAuthObj } from "utils/auth";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { LeadDashboardTable } from "./LeadDashboard.styles";
import { PrimaryColor, ScreenSize } from "utils/constants";
import { withAppContext } from "contexts/AppContext/AppContext";
import PicModal from "./component/PicModal";
import Locale from "react-intl-universal";

const Advisees = (props) => {
  const jwt = getUserAuthObj();
  const [query, setQuery] = useState({ currentPage: 1, limit: 10 });
  const {
    isLoading: isAdviseesLoading,
    paginatedData: advisees,
    total,
    refetch,
  } = useGetLeads(query);

  console.log("advisees", advisees);

  const [csv_data, set_csv_data] = useState([]);
  const [csv_header, set_csv_header] = useState([
    {
      label: "Creation Date",
      key: "createdAt",
    },
    {
      label: "Full Name",
      key: "name",
    },
    {
      label: "Contact Number",
      key: "contact",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "D.O.B.",
      key: "dob",
    },
    {
      label: "PIC",
      key: "assignedTo",
    },
  ]);

  const [visible, setVisible] = useState(false);
  const [adviseeUser, setAdviseeUser] = useState({});
  const [selectAssignPic, setSelectAssignPic] = useState(null);

  var GetLead = useGetLeads({ currentPage: 1, limit: null });
  // var GetPic = useGetUsers({ currentPage: 1, limit: null });

  // console.log("GetPic", GetPic);

  const HandleAssignPic = async () => {
    if (selectAssignPic) {
      await patchPic({
        leadId: adviseeUser._id,
        PICId: selectAssignPic,
      })
        .then((res) => {
          console.log(res, 66);

          message.success(Locale.get("leadDashboard.assignPicMsg"));
          setVisible(false);
          refetch();
          setSelectAssignPic(null);
        })
        .then((err) => {
          console.log(err);
        });
    } else {
      message.error(Locale.get("leadDashboard.errMsgSelectPic"));
    }
  };

  const generateCSV = () => {
    var order = [...GetLead.paginatedData];
    var csv_data = [];
    // var sum_balance = 0;

    for (let i = 0; i < order.length; i++) {
      const real_order = order[i];

      csv_data.push({
        name: real_order.name,
        dob: real_order.dob,
        email: real_order.email,
        contact: real_order.contact,
        assignedTo: real_order.assignedTo,
        createdAt: real_order.createdAt,
      });
    }

    set_csv_data(csv_data);

    return true;
  };

  const columns = [
    {
      ...constructColumn(
        Locale.get("leadDashboard.leadDashboardComponent.fullName"),
        "name",
        { hasSorter: true }
      ),
      ...getColumnFilterSearchProps("name", "Search name"),
    },
    {
      ...constructColumn(
        Locale.get("leadDashboard.leadDashboardComponent.dob"),
        "dob",
        { isDate: true }
      ),
    },
    {
      ...constructColumn(
        Locale.get("leadDashboard.leadDashboardComponent.contact"),
        "contact"
      ),
    },
    {
      ...constructColumn(
        Locale.get("leadDashboard.leadDashboardComponent.pic"),
        "assignedTo",
        { hasSorter: true }
      ),
      ...getColumnFilterSearchProps("assignedTo", "Search name"),
      render: (currentAssignedTo, record) => {
        return (
          (
            <div>
              {currentAssignedTo}{" "}
              {props.isAdmin && (
                <EditOutlined
                  style={{
                    marginLeft: 8,
                    color: PrimaryColor,
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setAdviseeUser(record);
                    setVisible(true);
                  }}
                />
              )}
            </div>
          ) || "(Not assigned)"
        );
      },
    },
    {
      ...constructColumn(
        Locale.get("leadDashboard.leadDashboardComponent.dos"),
        "createdAt",
        { hasSorter: true }
      ),
      render: (category) => {
        return category;
      },
    },
    {
      ...constructColumn(
        Locale.get("leadDashboard.leadDashboardComponent.action"),
        ""
      ),
      render: (category, record) => (
        <Button
          type="primary"
          onClick={() => {
            window.open(
              buildAWPersonalUri() + `?leadId=${record._id}`,
              "_blank"
            );
          }}
        >
          {Locale.get("leadDashboard.leadDashboardComponent.processLead")}
        </Button>
      ),
    },
  ];

  // const PicModal = (
  //   <Modal
  //     title={"Assign PIC"}
  //     visible={visible}
  //     onOk={HandleAssignPic}
  //     onCancel={() => {
  //       setSelectAssignPic(null);
  //       setVisible(false);
  //     }}
  //     width={window.innerWidth < ScreenSize.xl ? "100%" : 1200}
  //   >
  //     <Descriptions
  //       layout="vertical"
  //       size="small"
  //       column={{ xs: 1, md: 2, xl: 3 }}
  //       // column={3}
  //       bordered
  //     >
  //       <Descriptions.Item
  //         style={{ fontSize: 16 }}
  //         label={<span style={{ fontWeight: 600 }}>Name</span>}
  //       >
  //         {adviseeUser.name}
  //       </Descriptions.Item>
  //       <Descriptions.Item
  //         style={{ fontSize: 16 }}
  //         label={<span style={{ fontWeight: 600 }}>D.O.B.</span>}
  //       >
  //         {adviseeUser.dob}
  //       </Descriptions.Item>
  //       <Descriptions.Item
  //         style={{ fontSize: 16 }}
  //         label={<span style={{ fontWeight: 600 }}>Contact Number</span>}
  //       >
  //         {adviseeUser.contact}
  //       </Descriptions.Item>
  //       <Descriptions.Item
  //         style={{ fontSize: 16 }}
  //         label={<span style={{ fontWeight: 600 }}>Date of Submit</span>}
  //       >
  //         {adviseeUser.createdAt}
  //       </Descriptions.Item>
  //       <Descriptions.Item
  //         style={{ fontSize: 16 }}
  //         label={<span style={{ fontWeight: 600 }}>Current PIC</span>}
  //       >
  //         {adviseeUser.assignedTo}
  //       </Descriptions.Item>
  //       <Descriptions.Item
  //         style={{ fontSize: 16 }}
  //         label={<span style={{ fontWeight: 600 }}>Assign to New PIC</span>}
  //       >
  //         <Select
  //           placeholder="New PIC"
  //           value={selectAssignPic}
  //           filterOption={(searchInput, option) => {
  //             // console.log(searchInput, option);
  //             const regex = new RegExp(searchInput, "i");
  //             // console.log(option.children && regex.test(option.children));
  //             return option.children && regex.test(option.children);
  //           }}
  //           showSearch
  //           style={{ width: "100%" }}
  //           onChange={(e) => setSelectAssignPic(e)}
  //         >
  //           {GetPic?.paginatedData?.map((pic) => {
  //             return (
  //               <Select.Option key={pic._id} value={pic._id}>
  //                 {pic.name}
  //               </Select.Option>
  //             );
  //           })}
  //         </Select>
  //       </Descriptions.Item>
  //     </Descriptions>
  //   </Modal>
  // );

  return (
    <div>
      <Row justify="space-between" align="middle">
        <Title>{Locale.get("leadDashboard.pageTitle")}</Title>

        {jwt.role !== "free" && (
          <Row gutter={24}>
            {jwt.role === "admin" && (
              <Col>
                <CSVLink
                  data={csv_data}
                  headers={csv_header}
                  filename={`${moment().format("DD-MMM-YYYY")}_Advisees.csv`}
                  onClick={generateCSV}
                >
                  <Button
                    icon={
                      <CloudDownloadOutlined style={{ color: "#d7a301" }} />
                    }
                    style={{ color: "#d7a301", borderColor: "#d7a301" }}
                  >
                    {Locale.get("leadDashboard.csv")}
                  </Button>
                </CSVLink>
              </Col>
            )}

            <Col>
              <CopyToClipboard
                text={
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  buildLeadFormUri(jwt._id)
                }
                onCopy={() =>
                  message.success(
                    Locale.get("leadDashboard.copyLinkMsgSuccess")
                  )
                }
              >
                <Button
                  icon={<CopyOutlined />}
                  style={{ color: "#d7a301", borderColor: "#d7a301" }}
                >
                  {Locale.get("leadDashboard.copyLink")}
                </Button>
              </CopyToClipboard>
            </Col>

            <Col>
              <Button
                type="primary"
                icon={<UserAddOutlined />}
                onClick={() => {
                  window.open(buildLeadFormUri(jwt._id), "_blank");
                }}
                // style={{ color: "#d7a301", borderColor: "#d7a301" }}
              >
                {Locale.get("leadDashboard.leadForm")}
              </Button>
            </Col>
          </Row>
        )}
      </Row>

      <LeadDashboardTable
        loading={isAdviseesLoading}
        columns={columns}
        dataSource={advisees}
        // onRow={handleOnRow}
        onChange={(pagination, filters, sorter) =>
          handleOnAggregationTableChange(
            { pagination, filters, sorter },
            setQuery
          )
        }
        pagination={{ total, current: query.currentPage }}
        rowKey={(record) => record._id}
        showSorterTooltip={false}
        expandable={{
          expandRowByClick: true,
          expandedRowRender: (record) => <ExpandableRow data={record} />,
        }}
      />

      {/* {PicModal} */}

      {props.isAdmin && (
        <PicModal
          visible={visible}
          HandleAssignPic={HandleAssignPic}
          setSelectAssignPic={setSelectAssignPic}
          setVisible={setVisible}
          adviseeUser={adviseeUser}
          selectAssignPic={selectAssignPic}
        />
      )}
    </div>
  );
};

export default withAppContext(Advisees);
